export const TAB = {
  SEARCH_EVENTS: 'searchEvents',
  PRODUCT_CLICK: 'productClick',
  CONVERSATION_ACTIONS: 'conversationActions',
  FILTER_EVENTS: 'filterEvents',
  RECOMMENDATION_EVENTS: 'recommendationEvents'
};

export const TAB_CONTENT = [
  {
    label: 'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.searchEvents.title',
    value: TAB.SEARCH_EVENTS,
    content: [
      {
        title:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.searchEvents.contents.searchQuery.title',
        description:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.searchEvents.contents.searchQuery.content'
      },
      {
        title:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.searchEvents.contents.suggestionTermISWClick.title',
        description:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.searchEvents.contents.suggestionTermISWClick.content'
      },
      {
        title:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.searchEvents.contents.searchResultISWClick.title',
        description:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.searchEvents.contents.searchResultISWClick.content'
      },
      {
        title:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.searchEvents.contents.suggestionTermClick.title',
        description:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.searchEvents.contents.suggestionTermClick.content'
      }
    ]
  },
  {
    label: 'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.productClick.title',
    value: TAB.PRODUCT_CLICK,
    content: [
      {
        title:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.productClick.contents.productClick.title',
        description:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.productClick.contents.productClick.content'
      }
    ]
  },
  {
    label:
      'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.title',
    value: TAB.CONVERSATION_ACTIONS,
    content: [
      {
        title:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.addToCart.title',
        description:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.addToCart.content',
        childDescription: [
          "AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.addToCart.childContents.collectionProductCard",
          "AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.addToCart.childContents.productPage"
        ]
      },
      {
        title:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.buyNow.title',
        description:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.buyNow.content',
        childDescription: [
          "AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.buyNow.childContents.collectionProductCard",
          "AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.buyNow.childContents.productPage"
        ]
      },
      {
        title:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.preOrder.title',
        description:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.preOrder.content'
      },
      {
        title:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.notifyMe.title',
        description:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.conversationActions.contents.notifyMe.content'
      }
    ]
  },
  {
    label: 'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.filterEvents.title',
    value: TAB.FILTER_EVENTS,
    content: [
      {
        title:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.filterEvents.contents.filterOptionValueClick.title',
        description:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.filterEvents.contents.filterOptionValueClick.content'
      }
    ]
  },
  {
    label:
      'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.recommendationEvents.title',
    value: TAB.RECOMMENDATION_EVENTS,
    content: [
      {
        title:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.recommendationEvents.contents.boostWidgetView.title',
        description:
          'AdminHTML.GoogleAnalytics4.EventsIntegration.collapseContents.recommendationEvents.contents.boostWidgetView.content'
      }
    ]
  }
];
